import { EMlSearchSessionGuidActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setMlSearchSessionGuid = actionGenerator<EMlSearchSessionGuidActionType.Set, string | null>(
  EMlSearchSessionGuidActionType.Set,
);
